/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UploadType {
    ServiceReminderLetter = 0,
    ServiceReminderEmail = 1,
    ImageUpload = 2,
}
